$(document).on("turbo:load turbo:render", ()=>{


    if ($(".duplicates-comparison input:radio:checked").length){
        //@ts-ignore
        $(".duplicates-comparison input:submit").attr("disabled", false);

    }
    else{
        $(".duplicates-comparison input:submit").attr("disabled", 'true');

    }

    $(".duplicates-comparison input").on("change", ()=>{
        //@ts-ignore
        $(".duplicates-comparison input:submit").attr("disabled", false);

    })
});


function disableSubmitUnlessSelected(){
    let selected = false;
    $(".duplicates-comparison input:radio:checked").on("change", ()=>{

    });
}